<script setup lang="ts">
import { ref } from 'vue';
import type { PopupEvent } from '@/components/popup/popup/popup';
import type { Emits, Props } from './confirm';
import TopButton from '@/components/forms/button/button.vue';
import TopPopup from '@/components/popup/popup/popup.vue';

const props = defineProps<Props>();

const emit = defineEmits<Emits>();

const isSubmit = ref(false);

const onSubmit = () => {
	isSubmit.value = true;

	emit('submit');
};

const onClose = (popupEvent: PopupEvent) => {
	if (isSubmit.value) {
		isSubmit.value = false;

		return;
	}

	emit('close', popupEvent);
};

const $propsPopup = { ...props, submitText: undefined, cancelText: undefined, isWarning: undefined };
delete $propsPopup.submitText;
delete $propsPopup.cancelText;
delete $propsPopup.isWarning;
</script>

<template>
	<TopPopup
		class="top-popupConfirm"
		:=$propsPopup
		@open="$emit('open', $event)"
		@close="onClose($event)"
		@scrollContentList="(...args) => $emit('scrollContentList', ...args)"
	>
		<template #opener>
			<!-- @slot Элемент для открытия TopPopup -->
			<slot name="opener"></slot>
		</template>

		<template #header v-if="$slots.header">
			<!-- @slot Шапка -->
			<slot name="header"></slot>
		</template>

		<template #content v-if="$slots.default">
			<!-- @slot Контент в свободной форме -->
			<slot></slot>
		</template>

		<template #footer>
			<!-- @slot Футер -->
			<slot name="footer"></slot>

			<TopButton color="theme">
				{{ cancelText || $i18n.Common.Cancel }}
			</TopButton>

			<TopButton
				@click="onSubmit"
				:color="isWarning ? 'red' : 'blue'"
			>
				{{ submitText || $i18n.Common.Continue }}
			</TopButton>
		</template>
	</TopPopup>
</template>
